import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  GetReconciliationsResponse,
  GetReconciliationsRequest,
  ReconciliationDetailResponse as ReconciliationSummariesResponse,
  GetReconciliationDetailRequest as GetReconciliationSummariesRequest,
  ReconciliationReportResponse,
  GetReconciliationReportRequest,
  ExecuteReconciliationResponse,
  ExecuteReconciliationsRequest,
} from "./types";
import { baseQueryCreator } from "redux/baseQuery";
import env from "env";
import dayjs from "dayjs";

const { reconciliationService } = env.api.baseUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: reconciliationService,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const reconciliationApi = createApi({
  reducerPath: "reconciliationApi",
  baseQuery: baseQueryCreator(baseQuery),
  refetchOnMountOrArgChange: true,
  tagTypes: ["Reconciliation"],
  endpoints: (builder) => ({
    getReconciliations: builder.query<
      GetReconciliationsResponse,
      GetReconciliationsRequest
    >({
      query: (params) => {
        return {
          url: `/reconciliations`,
          method: "GET",
          params: {
            ...params,
            "date.greaterThanOrEqual": params["date.greaterThanOrEqual"]
              ? dayjs(params["date.greaterThanOrEqual"]).format("YYYY-MM-DD")
              : undefined,
            "date.lessThanOrEqual": params["date.lessThanOrEqual"]
              ? dayjs(params["date.lessThanOrEqual"])
                  .endOf("day")
                  .format("YYYY-MM-DD")
              : undefined,
          },
        };
      },
    }),
    executeReconciliation: builder.mutation<
      ExecuteReconciliationResponse,
      ExecuteReconciliationsRequest
    >({
      query: (params) => {
        return {
          url: `/reconciliations`,
          method: "POST",
          body: {
            ...params
          },
        };
      },
    }),
     getReconciliationSummaries: builder.query<
      ReconciliationSummariesResponse,
      GetReconciliationSummariesRequest
    >({
      query: (params) => {
        return {
          url: `/reconciliations/${params.id}/reconciliation-summaries?isDeleted.equals=false`,
          method: "GET",
        };
      },
    }),
    getReconciliationReport: builder.query<
      ReconciliationReportResponse,
      GetReconciliationReportRequest
    >({
      query: (params) => {
        return {
          url: `/reconciliations/${params.id}/reconciliation-reports?isDeleted.equals=false`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetReconciliationsQuery, useGetReconciliationSummariesQuery, useGetReconciliationReportQuery, useExecuteReconciliationMutation } = reconciliationApi;
export const { useQueryState: useGetReconciliationsState } =
  reconciliationApi.endpoints.getReconciliations;